import { Outlet, useLocation, useNavigate } from "react-router-dom";
import tele_menus from "../../../utils/tele_menu";
import { useContext, useEffect, useState } from "react";
import {
  LocalUser,
  RemoteUser,
  useIsConnected,
  useJoin,
  useLocalMicrophoneTrack,
  useLocalCameraTrack,
  usePublish,
  useRemoteUsers,
} from "agora-rtc-react";
import MeetingRoom from "./compomnents/MeetingRoom";
import { MeetingContext } from "./context/MeetingContext";
import { More, Microphone, Video, Messages, Profile } from "iconsax-react";
import { SocketContext } from "./context/SocketContext";
import { UserContext } from "./context/UserContext";
import instance from "../../../axios/instance";
import { getToken } from "../../../utils/token";
import uniqBy from "lodash.uniqby";
import timeAgo from "../../../utils/telemedicine/time_ago";
import { NoAccessInfo } from "../../../components/NoAccessInfo";
import { X } from "lucide-react";

export default function TeleLayout({ plan }) {
  // demo state which will be chamged to context
  const { meetingData, setMeetingData } = useContext(MeetingContext);
  const location = useLocation();

  const noAccessToTelemedicine = plan.noAccess.includes("/telemedicine");

  const isPrescriptionPage = location.pathname.includes(
    "/telemedicine/prescriptions",
  );
  const shouldShowContent = !noAccessToTelemedicine || isPrescriptionPage;

  return (
    <>
      {!meetingData ? null : <MeetingRoom meetingData={meetingData} />}
      <div className="grid grid-cols-12 m-4 shadow-lg border">
        <div className="col-span-3 bg-[#f1f1f1]">
          <TeleSidenav
            noAccess={noAccessToTelemedicine && !isPrescriptionPage}
          />
        </div>
        <div className="col-span-9 relative">
          {shouldShowContent ? (
            <Outlet />
          ) : (
            <div className="px-5">
              <NoAccessInfo
                msg={`Your current plan (${plan.name}) does not include the Telemedicine feature`}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function TeleSidenav({ noAccess }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [patientData, setPatientDate] = useState(null);

  return (
    <>
      {!patientData ? null : (
        <div className="fixed bg-[#20232b22] top-0 bottom-0 left-0 right-0 z-[1000]">
          <PatientModal
            patientData={patientData}
            onClose={() => setPatientDate(null)}
          />
        </div>
      )}
      <div className="h-[calc(100vh_-_32px)] col-span-3 border-r p-3 space-y-10 text-gray-800">
        <div className="space-y-4">
          <div className="uppercase font-semibold text-[13px]">
            Patient Queue
          </div>

          {/* <div className="text-[14px] text-gray-500">No one has checked in yet</div> */}
          <PatientQueue
            patientData={(data) => {
              //console.log(data);
              if (data) {
                setPatientDate(data);
              }
            }}
            noAccess={noAccess}
          />
        </div>
        <div className="space-y-1">
          <div className="uppercase font-semibold text-[13px]">Account</div>
          <div className="space-y-2">
            {tele_menus.map((menu) => (
              <div
                onClick={() => navigate(menu.route)}
                key={menu.id}
                className={`${
                  location.pathname === menu.route
                    ? "border-2 border-[#00b0ad80] text-[#00b0ad]"
                    : "border-2 border-transparent text-gray-800"
                } hover:border-[#00b0ad80] cursor-pointer p-2 flex gap-2 items-center text-[14px] rounded-[6px]`}
              >
                <div
                  className={`${
                    location.pathname === menu.route
                      ? "text-[#00b0ad]"
                      : "text-gray-800"
                  }`}
                >
                  {menu.icon}
                </div>
                {menu.title}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

function PatientQueue({ patientData, noAccess }) {
  const socket = useContext(SocketContext);
  const { user } = useContext(UserContext);

  const [queueLoading, setQueueLoading] = useState(false);

  const [socketLoading, setSocketLoading] = useState(false);

  const [queue, setQueue] = useState([]);
  const [queueFromDb, setQueueFromDb] = useState([]);

  useEffect(() => {
    getQueue();
  }, [socket]);

  async function getQueue() {
    console.log("Queue function running");
    setSocketLoading(true);

    //socket.emit("join_room", "test_room")

    socket.on("get_queue", (data) => {
      const myQueue = data?.results.filter(
        (item) => item.doctor_id == user?.id,
      );

      console.log("my queue is this", myQueue);

      //setQueue(data.results)

      setQueue(myQueue);
      //setQueue((prev) => [...prev, myQueue]);

      setSocketLoading(false);
      // repitition exists fix it
    });
  }

  async function getQueueFromDb() {
    setQueueLoading(true);
    instance
      .get("/telemedicine/doctor/meetings/queue", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setQueueFromDb(response.data);
        // merge queue
        const newQueue = response.data.concat(queue);

        setQueue(newQueue);
        setQueueLoading(false);
      })
      .catch((error) => {
        console.log(error.response.data);
        setQueueFromDb([]);
        setQueueLoading(false);
      });
  }

  function handlePatientData(item) {
    patientData(item);
    // console.log(item);
  }

  useEffect(() => {
    getQueueFromDb();
  }, []);

  return (
    <>
      {queueLoading ? (
        <div>Fetching queue...</div>
      ) : (
        <div className="space-y-4">
          {queue?.length < 1 ? (
            <div className="text-[14px] text-gray-400">
              No patient in queue yet
            </div>
          ) : (
            uniqBy(queue, "id")
              .slice(0, 3)
              ?.map((item) => (
                <div
                  key={Math.random() * 999}
                  className="flex justify-between items-center"
                >
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full text-[12px] uppercase text-[#20232b] font-medium bg-gray-300 flex justify-center items-center">
                      {/* <Profile size={22} color="#20232b" variant="Bold" /> */}
                      {/* {item?.patient_name[0]}
                      {item?.patient_name[item?.patient_name.length - 1]} */}

                      <Profile size={22} color="#20232b" variant="Bold" />
                    </div>
                    <div>
                      <div className="text-[12px] font-medium">
                        {item?.patient_name}
                      </div>
                      <div className="text-[12px] text-[#00b0ad]">
                        Waiting {timeAgo(item?.created_at)}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => handlePatientData(item)}
                    disabled={noAccess}
                  >
                    <More size={16} />
                  </button>
                </div>
              ))
          )}
        </div>
      )}
    </>
  );
}

function PatientModal({ onClose, patientData }) {
  // const { setMeetingData } = useContext(MeetingContext)

  const socket = useContext(SocketContext);

  const navigate = useNavigate();

  function handleDoctorJoin(meetingData) {
    console.log(meetingData);

    socket.emit("doctor_join", { meeting: meetingData });

    // socket.emit("meeting_check", { meeting: { id: 2 }})

    socket.on("doctor_joined", (data) => {
      console.log(data);

      navigate("/dashboard/telemedicine/meeting", { state: data });
    });

    // change patient data to meeting data
  }

  return (
    <div className="w-[600px] bg-white text-black border p-3 shadow-md top-6 left-[560px] z-[800] absolute flex gap-3 items-center">
      <button onClick={onClose} className="absolute top-3 right-3">
        <X size={20} />
      </button>
      <div className="w-28 h-28 bg-gray-200 rounded-full flex justify-center items-center">
        <Profile size={52} variant="Bold" color="#20232b" />
      </div>
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div className="font-semibold">{patientData?.patient_name}</div>
          <div className="text-[#00b0ad] flex gap-1 items-center">
            <Microphone size={18} variant="Bold" />
            <Video size={18} variant="Bold" />
          </div>
        </div>

        <div className="text-[14px]">
          Waiting time {timeAgo(patientData?.created_at)}
        </div>

        <div className="flex gap-3">
          {/* <button className="flex gap-2 bg-[#00b0ad] items-center text-[14px] font-medium text-white px-3 py-2 rounded-[4px]">
                        <Messages size={20} variant="Bold" />
                        <div>Chat</div>
                    </button> */}

          <button
            onClick={() => handleDoctorJoin(patientData)}
            className="flex gap-2 bg-[#00b0ad] items-center text-[14px] font-medium text-white px-3 py-2 rounded-[4px]"
          >
            <Video size={20} variant="Bold" />
            <div>Join meeting</div>
          </button>
        </div>
      </div>
    </div>
  );
}
